import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  users: [],
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addUsers: (state, action) => {
      state.users = action.payload
    },
    deleteUser: (state, action) => {
      state.users.filter(user => action.payload.id != user.id)
    },
    updateUser: (state, action) => {
      state.users.map(user => {
        if (user.id == action.payload.id) return action.payload
        return user
      })
    },
  },
})

// Action creators are generated for each case reducer function
export const { addUsers } = userSlice.actions

export default userSlice.reducer